import React, { useEffect, useState } from "react";
import { getFeedLanding, getFeedUserBased } from "../../api/api";
import Banner from "../banner";
import Carousel from "../carousel";

const Home = () => {
  const [items, setItems] = useState([]);

  const getVideoFeeds = async () => {
    const { data } = await getFeedLanding();
    if (data?.items?.length) {
      setItems(data.items);
    }
  };

  const renderedItems = items.map((item) => {
    if (item.type === "banner") {
      return <Banner key={item.id} bannerId={item.id} />;
    }
    // else if (item.type === "videoThumbnail") {
    //     return <Carousel key={item.id} carouselId={item.id} title={item.title}/>
    // }
    else if (
      (item.type === "videoThumbnail" || item.type === "video") &&
      item?.title
    ) {
      return <Carousel key={item.id} carouselId={item.id} title={item.title} />;
    }
  });

  useEffect(() => {
    getVideoFeeds();
  }, []);

  return <div>{renderedItems}</div>;
};

export default Home;
